





































































import { computed, defineComponent, ref } from "@vue/composition-api";
import config from "@/config";
import { FormValues } from "@/types";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseForm from "@/components/BaseForm";
import SafeForWorkStatusSettings from "@/components/SafeForWorkStatusSettings";
import PayeeInfoInputFile from "./PayeeInfoInputFile.vue";
import { personalIdFields } from "../config";

export default defineComponent({
  name: "SafeForWorkSetup",
  components: {
    BaseCheckbox,
    PayeeInfoInputFile,
    BaseForm,
    SafeForWorkStatusSettings,
  },
  setup(_, { emit }) {
    const isSensitiveAgreement = ref(false);
    const fields = computed(() => personalIdFields());
    const valid = ref(false);
    const acknowledgeAgreement = ref(false);

    const values = computed<FormValues>(() => {
      return {
        ...(config.featureNSFW
          ? { sensitiveContent: isSensitiveAgreement.value, acknowledgeAgreement: acknowledgeAgreement.value }
          : {}),
      };
    });

    const checkValid = () => {
      if ((config.featureNSFW && !isSensitiveAgreement.value) || !acknowledgeAgreement.value || !valid.value) {
        return emit("setValid", false);
      }
      return emit("setValid", true);
    };

    const inputSensitive = (v: boolean) => {
      isSensitiveAgreement.value = v;
      checkValid();
    };

    const inputAcknowledge = (v: boolean) => {
      acknowledgeAgreement.value = v;
      checkValid();
    };

    checkValid();

    return {
      values,
      valid,
      fields,
      inputAcknowledge,
      inputSensitive,
    };
  },
});
